import React from "react";
import WithDrawCrypto from "./components/WithDrawCrypto";
import WithDrawSOT from "./components/WithDrawSOT";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { CountryCode, TYPE_WALLET_DETAIL } from "../../constants";
import WithDrawGameCurrency from "./components/WithDrawGameCurrency";
import { TitleWithBack } from "../../components/Layout";
import { useApp } from "../../contexts";

const WithDraw = () => {
  const { user } = useApp();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  let { type, walletId, code } = {
    type: searchParams.get("type"),
    id: searchParams.get("id"),
    code: searchParams.get("code"),
    walletId: searchParams.get("walletId"),
    ...(useParams() || {}),
  };
  const renderView = () => {
    switch (type) {
      case TYPE_WALLET_DETAIL.CRYPTO:
        return <WithDrawCrypto />;
      case TYPE_WALLET_DETAIL.OPTION:
        return <WithDrawSOT />;
      case TYPE_WALLET_DETAIL.GAMECURRENCY:
      case TYPE_WALLET_DETAIL.COMMISSION:
        return <WithDrawGameCurrency />;
      default:
        return null;
    }
  };
  // if (type === TYPE_WALLET_DETAIL.COMMISSION) {
  //   if (user?.country_code !== CountryCode.indo) return navigate("/");
  // }
  return <div>{renderView()}</div>;
};
export default WithDraw;
